export default __webpack_public_path__ + "static/media/luka-velimirovic.93bf5ccd.jpeg";